import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PaymentInfo from './PaymentInfo';
import EmptyResult from 'components/others/EmptyResult';

interface Props {
    payments: Record<string, any>[] | null;
    error: boolean;
}

const TabPaymentsList = ({ payments, error }: Props) => {
    const { t } = useTranslation(['Objects', 'Warehouses', 'common']);

    if (error) return <div className="text-danger mt-3">{t('common:messError')}</div>;

    const safePayments = Array.isArray(payments) ? payments : [];

    if (safePayments.length === 0) {
        return (
            <div className="my-3">
                <EmptyResult />
            </div>
        );
    }

    return (
        <div className="crm-table-wrap my-3">
            <Table className="OffPaymentsTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-date">{t('Warehouses:fields.date')}</td>
                        <td className="head-user">{t('Warehouses:fields.userName')}</td>
                        <td className="head-amount">{t('documents.payments.labelAmount')}</td>
                        <td className="head-description" title={t('documents.payments.labelDescription')}>
                            <i className="bi bi-chat-left-text"></i>
                        </td>
                        <td className="head-attach">{t('common:labelAttachments')}</td>
                    </tr>
                </thead>
                <tbody>
                    {safePayments.map((payment, index) => (
                        <PaymentInfo key={payment?.ID ?? index} payment={payment} />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TabPaymentsList;
